import { WizardProps } from './Types'
import { useGenerateContent } from './Wizard/useGenerateContent'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { BaseWizard } from './BaseWizard'

export const Wizard = observer(
  ({
    articleId,
    layerId,
    nodeSelection,
    onSuccess,
    bodyClassName,
    initialValues = {},
    initialFormStatus,
    stepperVariant,
    schema,
  }: WizardProps) => {
    const handbooksStore = useRootStore().handbooks
    const { promptLibrary, type } = schema.describe().meta

    const { generateContent } = useGenerateContent({
      generationType: type,
      articleId,
      layerId,
      nodeSelection,
      onSuccess,
      promptLibrary,
    })

    return (
      <BaseWizard
        articleId={articleId}
        schema={schema}
        onSubmit={async (values) => {
          await generateContent(values)
          handbooksStore.refresh(values.project?.handbook?.key)
        }}
        bodyClassName={bodyClassName}
        stepperVariant={stepperVariant}
        initialValues={initialValues}
        initialFormStatus={initialFormStatus}
      />
    )
  },
)
